import { z } from "zod";
import { DatetimeString } from "./datetime.js";
import { type ParserType, parser } from "./parser.js";
import { Tags } from "./tag.js";

export type TaskChecklistItem = ParserType<typeof TaskChecklistItem>;
export const TaskChecklistItem = parser(
  z.strictObject({
    isChecked: z.boolean(),
    description: z.string(),
  }),
);

export type TaskChecklist = ParserType<typeof TaskChecklist>;
export const TaskChecklist = parser(z.array(TaskChecklistItem.schema));

export type Task = ParserType<typeof Task>;
export const Task = parser(
  z.strictObject({
    id: z.string(),
    description: z.string(),
    dueBy: z.optional(DatetimeString.schema),
    createdAt: DatetimeString.schema,
    tags: Tags.schema,
  }),
);

export type Tasks = ParserType<typeof Tasks>;
export const Tasks = parser(z.array(Task.schema));
